import { Box } from "@mui/material";
import styled, { css } from "styled-components";
import { SubSectionContainerText } from "components/SubSection/SubSection.styled";
import { Highlight } from "components/Hightlight/Hightlight.style";
import WrapperAlt from "assets/images/svg/bottom_left_hover_w.svg";
import WrapperAltBlue from "assets/images/svg/bottom_left_hover_w_blue.svg";
import Wrapper from "assets/images/svg/vectors_wrapper_bottom_left_w.svg";
import {
  HighlightLinkContener,
  HighlightText,
  Link,
} from "components/Hightlight/Hightlight.style";

export const ProjectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 54px;

  @media (max-width: 1024px) {
    gap: 32px;
  }
`;

export const CaseStudyContainer = styled(Box)`
  gap: 40px;
  margin-bottom: 160px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 1200px) {
    gap: 10px;
    padding: 0px 5px;
  }
  @media (max-width: 1024px) {
    gap: 10px;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    margin-bottom: 40px;
    min-height: 320px;
  }
`;

export const CaseStudyParagraphHeader = styled(Box)`
  position: relative;
  display: block;
  font-size: 56px;
  font-stretch: expanded;
  line-height: 82px;
  letter-spacing: -1px;
  color: ${(props) => props?.theme.colors?.white};
  background-color: ${(props) => props?.theme.colors?.dark};
  width: auto;
  font-weight: 300;
  white-space: nowrap;
  border-top-right-radius: 16px;
  min-width: calc(565px - ${(props) => props?.$imgWidth});
  padding: 0px 27px 0px 27px;

  ${(props) =>
    !props?.$radius &&
    css`
      &:last-of-type {
        border-top-right-radius: 0px;
      }
    `}

  &:first-of-type {
    border-top-right-radius: 0px;
    border-top-left-radius: 16px;
    padding-top: 27px;
  }

  &:after {
    transform: translateX(18px);
    position: absolute;
    z-index: -1;
    content: "";
    background-image: url(${Wrapper});
    background-size: cover;
    background-position: center;
    height: 20px;
    width: 20px;
    bottom: 0;
    right: 1px;
  }

  @media (max-width: 1024px) {
    font-size: 28px;
    letter-spacing: -0.496392px;
    font-weight: 300;
    line-height: 40.7px;
    white-space: nowrap;
    min-width: calc((260px - ${(props) => props?.$imgWidth}));
    padding: 0px 17px 0px 14px;

    & ${Highlight} {
      font-weight: 800;
    }

    &:first-of-type {
      padding-top: 15px;
    }
  }

  @media (max-width: 600px) {
    &:after {
      transform: translateX(10px);
      position: absolute;
      z-index: -1;
      content: "";
      background-image: url(${Wrapper});
      background-size: cover;
      background-position: center;
      height: 10px;
      width: 10px;
      bottom: 0;
      right: 1px;
    }
  }
`;

export const CaseStudyParagraphHeaderAlt = styled(CaseStudyParagraphHeader)`
  border-top-right-radius: 16px;
  white-space: nowrap;
  ${(props) =>
    !props?.$radius &&
    css`
      border-top-right-radius: 0px;
    `}

  @media (max-width: 1024px) {
    padding-right: ${(props) => (props?.$padding ? "50px" : "14px")};
  }
`;

export const CaseStudyInnerContainer = styled.div`
  display: flex;
  flex-direction: column;

  height: 573px;
  max-width: 565px;
  border-radius: 24px;
  background-color: ${(props) => props?.theme?.colors.dark};
  padding: 0 0 24px 0;

  cursor: pointer;

  ${(props) =>
    !props?.isMobile &&
    css`
      &:hover {
        background-color: ${(props) =>
          props?.theme?.colors?.[props.$highlightColor]};

        & ${CaseStudyParagraphHeader}, & ${CaseStudyTextContainer} {
          background-color: ${(props) =>
            props?.theme?.colors?.[props.$highlightColor]};
          color: ${(props) => props?.theme?.colors.dark};
        }

        & ${Circle} svg {
          transform: rotate(0deg);
        }

        ${CaseStudyParagraphHeader}:after,
        ${CaseStudyParagraphHeaderAlt}:after,
        ${CaseStudyHeader}:after {
          background-image: url(${(props) =>
            props?.$isInHouseProject ? WrapperAlt : WrapperAltBlue});
        }
      }
    `}
  @media (max-width: 1024px) {
    height: 320px;
    min-width: 288px;
    max-width: 288px;
    padding: 0px;
  }
`;

export const StatNumber = styled.div`
  font-weight: 700;
  font-size: 26.47px;
  line-height: 100%;
  letter-spacing: -0.74px;
  text-align: center;

  color: ${(props) => props?.theme?.colors.pureWhite};
  ${CaseStudyInnerContainer}:hover & {
    color: ${(props) => props?.theme?.colors.dark};
  }

  @media (max-width: 1024px) {
    font-size: 14px;
    letter-spacing: -0.37px;
  }

  @media (max-width: 600px) {
    ${CaseStudyInnerContainer}:hover & {
      color: ${(props) => props?.theme?.colors.pureWhite};
    }
  }
`;

export const StatLabel = styled.div`
  font-weight: 500;
  font-size: 14.8px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: ${(props) => props?.theme?.colors.pureWhite};
  ${CaseStudyInnerContainer}:hover & {
    color: ${(props) => props?.theme?.colors.dark};
  }

  @media (max-width: 1024px) {
    font-size: 8px;
  }

  @media (max-width: 600px) {
    ${CaseStudyInnerContainer}:hover & {
      color: ${(props) => props?.theme?.colors.pureWhite};
    }
  }
`;

export const CaseStudyHeader = styled(CaseStudyParagraphHeader)`
  font-size: 14px;
  font-weight: 600;
  line-height: 100%;
  border-top-right-radius: 16px;
  text-transform: uppercase;
  padding-bottom: 10px;
  font-stretch: normal;

  @media (max-width: 1024px) {
    font-size: 10px;
  }
`;

export const CaseStudyTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;

  color: ${(props) => props?.theme?.colors.secondTextColor};
  background-color: ${(props) => props?.theme?.colors.dark};

  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  position: relative;
  padding: 24px 27px 0;

  @media (max-width: 1024px) {
    padding: 12px 13px;
    gap: 10px;
    padding: 0px 14px 12px 14px;
  }
`;

export const CaseStudyText = styled.div`
  line-height: 125%;

  ${Highlight} {
    padding: 3px 1px;
    letter-spacing: 0.18px;
  }

  @media (max-width: 1024px) {
    font-size: 12px;
    font-weight: 400;
  }
`;

export const ProjectSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-height: 159px;
  min-height: 60px;
  gap: 16px;
`;

export const StatsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  gap: 24px;

  @media (max-width: 1024px) {
    padding: 0px 7px;
  }
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  max-width: 125px;
  gap: 7.5px;

  @media (max-width: 1024px) {
    max-width: 90px;
    gap: 4px;
  }
`;

export const CircleContainer = styled.div`
  max-width: 511px;
  min-width: 442px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: auto;

  @media (max-width: 1024px) {
    min-width: 250px;
    height: 32px;
  }
`;

export const Circle = styled(Link)`
  border-radius: 160px;
  width: 62px;
  height: 62px;
  background-color: ${(props) => props?.theme?.colors.pureWhite};
  display: flex;
  justify-content: center;
  align-items: center;

  & svg {
    transform: rotate(90deg);
    transition: transform 0.3s ease-in-out;
  }

  @media (max-width: 1024px) {
    width: 32px;
    height: 32px;
    margin-bottom: 0;
    position: absolute;
    right: 13px;
    bottom: 12px;

    & svg {
      transform: unset;
      transition: unset;
      width: 12px;
    }
  }
`;

export const PillsGroup = styled.div`
  display: flex;
  gap: 14px;
  @media (max-width: 1024px) {
    gap: 8px;
    overflow-x: auto;
  }
`;

export const Pill = styled.div`
  border-radius: 16px;
  height: ${(props) => (props?.$isFilter ? "40px" : "30px")};
  padding: 0 14px;
  font-size: ${(props) => (props?.$isFilter ? "16px" : "14px")};
  font-weight: 500;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  cursor: ${(props) =>
    props?.$isFilter && !props.$isSelected ? "pointer" : "default"};

  color: ${(props) => props.theme.colors.cardTextColor};
  background-color: ${(props) =>
    props.$isFilter
      ? props.$isSelected
        ? props.theme.colors.secondary
        : props.theme.colors.pureWhite
      : props.$isFirst
      ? props.$inHouseProject
        ? props.theme.colors.thertiary
        : props.theme.colors.secondaryOpaque
      : props.theme.colors.pureWhite};

  @media (max-width: 1024px) {
    font-size: ${(props) => (props?.$isFilter ? "16px" : "8px")};
    height: ${(props) => (props?.$isFilter ? "40px" : "16px")};
    padding: ${(props) => (props?.$isFilter ? "12px 24px" : "4px 8px")};
  }
`;

export const CaseStudyImageParagraph = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  text-decoration: none;

  grid-row-gap: 10px;
  // position: absolute;
  //right: 0px;
  //top: 0px;
  //width: 100%;
  border-top-right-radius: 16px;

  @media (max-width: 1024px) {
    display: flex;
    position: relative;
    right: unset;
    top: unset;
  }
`;

export const CaseStudyParagraph = styled(Box)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-decoration: none;
  display: flex;
  z-index: 1;

  border-top-left-radius: 16px;
`;

export const CaseStudyParagraphText = styled(Box)`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  & ${HighlightLinkContener}, & ${HighlightText}, & ${Link} {
    width: 100%;
    max-width: 370px;
    font-size: 24px;
    font-weight: 400;
    line-height: 150%;
  }
  & ${SubSectionContainerText}, & ${HighlightLinkContener} {
    background-color: ${(props) => props?.theme.colors?.white};
    padding: 0px 8px 4px 8px;
    margin: 0;
  }

  & ${HighlightText} {
    margin-top: 8px;
    margin-left: -2px;
  }
  @media (max-width: 1170px) {
    justify-content: center;
    & ${HighlightLinkContener} {
      font-size: 16px;
      line-height: 24px;
      margin-top: 65px;
      padding: 0 10px 0 0;
    }

    & ${Highlight}, & ${HighlightText}, & ${Link}, & ${HighlightLinkContener} {
      font-size: 16px;
      max-width: 95%;
      line-height: 24px;
    }

    & ${HighlightText} {
      margin-top: 4px;
      margin-left: -2px;
    }
  }

  @media (max-width: 512px) {
    & ${Highlight} {
      display: inline;
    }
  }
`;

export const CaseStudyImage = styled.div`
  border-top-left-radius: 0;
  border-top-right-radius: 20px;

  width: 100%;
  height: 100%;

  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: cover;
`;

export const CaseStudyImageContainer = styled.div`
  position: absolute;
  margin-left: 132px;
  z-index: 0;

  display: flex;
  justify-content: stretch;

  width: 433px;
  height: ${(props) => props?.$options?.height || "297px"};

  @media (max-width: 1170px) {
    max-width: 433px;
    width: auto;
    min-width: calc(50% - 142px);
  }

  @media (max-width: 1024px) {
    min-width: 198px;
    max-height: 315px;

    margin-left: 90px;
    max-width: 442px;
    width: auto;
  }

  ${CaseStudyImage} {
    ${(props) =>
      props?.$options?.position &&
      css`
        background-position: ${props?.$options?.position};
      `}
    ${(props) =>
      props?.$options?.bgSize &&
      css`
        background-size: ${props?.$options?.bgSize};
      `}
  }
`;

export const Bold = styled.span`
  font-weight: 800;
  font-stretch: expanded;
  padding: ${(props) => (props.$biggerPadding ? "0px 17px 0px 0px" : "0px")};
`;

export const CaseStudyImageParagraphContainer = styled(Box)`
  width: 100%;
`;
